// Copyright 2017 Sorama B.V.

import { BindingEngine, bindingMode, customAttribute, DOM, inject } from "aurelia-framework";

@customAttribute("scrolling-element", bindingMode.twoWay)
@inject(DOM.Element, BindingEngine)
export class ScrollingElement {
    //#region Injected Services
    private element: HTMLElement;
    private bindingEngine: BindingEngine;
    //#endregion

    //#region Constructor and Aurelia Callbacks
    constructor(element: HTMLInputElement, bindingEngine: BindingEngine) {
        this.element = element;
        this.bindingEngine = bindingEngine;
    }

    private bind(): void {
        this.element.onscroll = this.elementScrolled;
        this.element.classList.add("scrolling-element");
        this.applyClasses();
    }

    private unbind(): void {
        this.element.onscroll = null;
        this.element.classList.remove("scrolling-element");
        this.element.classList.remove("scrolling-element-top");
        this.element.classList.remove("scrolling-element-bottom");
    }
    //#endregion

    //#region Callbacks
    private elementScrolled = (event: UIEvent): void => {
        this.applyClasses();
    };
    //#endregion

    //#region Helper Methods
    private applyClasses(): void {
        if (this.element.scrollHeight <= this.element.clientHeight) return;

        if (this.element.scrollTop - 1 <= 0) {
            // Scrolled all the way to the top
            this.element.classList.remove("scrolling-element-bottom");
            this.element.classList.add("scrolling-element-top");
        } else if (this.element.scrollTop + this.element.clientHeight + 1 >= this.element.scrollHeight) {
            // Scrolled all the way to the bottom
            this.element.classList.remove("scrolling-element-top");
            this.element.classList.add("scrolling-element-bottom");
        } else {
            // Scrolled in the middle
            this.element.classList.add("scrolling-element-top");
            this.element.classList.add("scrolling-element-bottom");
        }
    }
    //#endregion
}
